import { createContext } from 'react';
import { PlannerMapDataElement } from 'components/common/types/Planner.types';
import { UsePOIResult } from '../PlannerMap/poiWorker/usePOI.types';

export interface PlannerData {
  poiResult: UsePOIResult;
  clusterAssetsData: PlannerMapDataElement[];
  handleViewportChange: (data: PlannerMapDataElement[]) => void;
}

export const PlannerDataContext = createContext<PlannerData | null>(null);
